class ProductSizeChart extends HTMLElement {
  constructor() {
    super();

    this.sizeChartId = this.getAttribute(this.attributes.sizeChartId);

    this.initSizeChart();
  }

  get attributes() {
    return {
      pageHandle: "page-handle",
      sizeChartId: "size-chart-id",
      sizeChartIds: "data-identifiers"
    }
  }

  async initSizeChart() {
    await this.renderSizeChartContent();
  }

  async renderSizeChartContent() {
    const pageHandle = this.getAttribute(this.attributes.pageHandle);

    if (!pageHandle) {
      return;
    }

    const pageContent = await this.getSizeChartContent(pageHandle);

    if (!pageContent) {
      return;
    }

    const sizeChartContent = [...pageContent.querySelectorAll(`[${this.attributes.sizeChartIds}*=${this.sizeChartId}]`)].find(
      (sizeChartElement) => {
        const sizeChartIdentifiers = sizeChartElement
          .getAttribute(this.attributes.sizeChartIds)
          .split(",");

        return sizeChartIdentifiers.map((identifier) =>
          identifier.trim().includes(this.sizeChartId)
        );
      }
    ) || null;

    if (!sizeChartContent) {
      return;
    }

    this.innerHTML = sizeChartContent.outerHTML;
  }

  async getSizeChartContent(pageHandle) {
    if (!pageHandle) {
      return;
    }

    const pageContent = await fetch(`${Shopify.routes.root}pages/${pageHandle}`).then(
      (data) => data.text()
    );

    return new DOMParser().parseFromString(pageContent, "text/html");
  }
}

if (!customElements.get("product-size-chart")) {
  customElements.define("product-size-chart", ProductSizeChart);
}
